import { render, staticRenderFns } from "./PeriodStats.vue?vue&type=template&id=643bbf83&"
import script from "./PeriodStats.vue?vue&type=script&lang=js&"
export * from "./PeriodStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports